<template>
  <section id="non-constrained-main-content">
    <div class="mult-main-content">
      <h1 v-if="currentSubsModel === 'onhb'">Montagem das equipes</h1>
      <h1 v-if="currentSubsModel === 'preonhb' && subsStillGoing">Dados adicionais da sua equipe</h1>
    </div>
    <!-- <p>{{registrationProcesses}}</p> -->
    <div id="filter" v-if="currentSubsModel === 'onhb' && processes.length > 1">
      <h3>Mostrar equipes:</h3>
      <div class="switch-container">
        <label class="switch">
          <input
            type="checkbox"
            @click="swapFilters('Todas as equipes')"
            :disabled="selectedFilters['Todas as equipes']"
            :checked="selectedFilters['Todas as equipes']"
          />
          <span class="slider"></span>
        </label>
        <span @click="swapFilters('Todas as equipes')" class="switch-label">Todas</span>
      </div>
      <div class="switch-container">
        <label class="switch">
          <input
            type="checkbox"
            @click="swapFilters('Equipe tem professor(a) responsável')"
            :checked="selectedFilters['Equipe tem professor(a) responsável']"
          />
          <span class="slider"></span>
        </label>
        <span
          @click="swapFilters('Equipe tem professor(a) responsável')"
          class="switch-label"
        >Sem professor(a) responsável</span>
      </div>
      <div class="switch-container">
        <label class="switch">
          <input
            type="checkbox"
            @click="swapFilters('Três estudantes com conta')"
            :checked="selectedFilters['Três estudantes com conta']"
          />
          <span class="slider"></span>
        </label>
        <span
          @click="swapFilters('Três estudantes com conta')"
          class="switch-label"
        >Faltam estudantes</span>
      </div>
      <div class="switch-container">
        <label class="switch">
          <input
            type="checkbox"
            @click="swapFilters('Boleto quitado')"
            :checked="selectedFilters['Boleto quitado']"
          />
          <span class="slider"></span>
        </label>
        <span @click="swapFilters('Boleto quitado')" class="switch-label">Falta pagar</span>
      </div>
      <div class="switch-container">
        <label class="switch">
          <input
            type="checkbox"
            @click="swapFilters('Equipe nomeada')"
            :checked="selectedFilters['Equipe nomeada']"
          />
          <span class="slider"></span>
        </label>
        <span @click="swapFilters('Equipe nomeada')" class="switch-label">Falta um nome</span>
      </div>
    </div>

    <div class="no-processes" v-if="processes.length === 0 && subsStillGoing && !amILoading && currentSubsModel === 'onhb'">
      <p><br><br><br>Você ainda não está em nenhuma inscrição para a 41ª OMU. <a class="btn-action" href="/inscricoes/omu_2025/new">Iniciar uma inscrição</a></p>
    </div>
    <div class="no-processes" v-if="processes.length === 0 && subsStillGoing && !amILoading && currentSubsModel === 'preonhb'">
      <p><br><br><br>Você ainda não está se inscrevendo para a Pré-ONHB 2020. <a class="btn-action" href="/inscricoes/pre_onhb2020/new">Iniciar uma inscrição</a></p>
    </div>


    <section
            v-for="proc in processes"
            :key="proc.NewSuiApplication.id"
            class="registration-process"
            :id="`process-n-${proc.NewSuiApplication.id}`"
    >
      <header class="reg-proc-head" v-if="currentSubsModel == 'onhb'">
        <font-awesome-icon icon="clock" v-if="!(proc.NewSuiPayment.status == 'received')" />
        <h2>Processo de inscrição #{{ proc.NewSuiApplication.id }}</h2>
        <h3>Código do processo: {{proc.NewSuiApplication.code}}</h3>

        <p
                class="number-of-teams"
        >Este processo contempla {{proc.Teams.length}} equipe{{proc.Teams.length!=1?'s':''}}.</p>

        <div v-if="proc.NewSuiApplication.status === 'completed' || proc.NewSuiPayment.status == 'received'" class="payment-status billet-was-paid">
          <p>
            >>>
            O boleto associado a este processo de inscrição foi quitado no prazo.
          </p>
        </div>
        <div v-if="proc.NewSuiApplication.status === 'in_proccess' && proc.NewSuiPayment.status == 'waiting'" class="payment-status billet-wasnt-paid-yet">
          <p>
            >>>
            <strong>Pagamento ainda não foi detectado</strong>.
            <br />
            Vencimento do boleto: {{ proc.NewSuiPayment.due_date | dateToBr }}
          </p>
        </div>

        <div v-if="proc.NewSuiApplication.status === 'in_proccess' && proc.NewSuiPayment.status == 'expired'" class="payment-status billet-expired">
          <p>
            >>>
            <strong>Pagamento vencido.</strong> Passou o prazo de compensação e o pagamento não foi detectado.
          </p>
        </div>

        <div class="payment-responsibility" v-if="proc.NewSuiApplication.status === 'in_proccess' && proc.NewSuiPayment.status != 'received'">
          <template v-if="currentUser.id == proc.NewSuiPayment.sui_user_id">
            <a v-if="proc.NewSuiPayment.status != 'expired'" :href="proc.NewSuiPayment.link" onclick="window.open(this.href, '_blank', 'menubar=0,toolbar=0,status=0,scrollbars=1,width=815,height=400'); return false;">Baixar boleto</a>
            <a v-else :href="proc.NewSuiPayment.link" onclick="window.open(this.href, '_blank', 'menubar=0,toolbar=0,status=0,scrollbars=1,width=815,height=400'); return false;">Consultar boleto vencido</a>
            &emsp;
            <a href="" @click.prevent="createNewBillet(proc)" v-if="subsStillGoing">Atualizar a cobrança</a>

            <a v-if="proc.NewSuiPayment.status === 'expired'" href="" @click.prevent="showAlreadyPaid">Mas... eu já paguei!</a>

            <a href="" @click.prevent="cancelProcess(proc, teamsByProcess[proc.NewSuiApplication.id])" v-if="subsStillGoing">Cancelar este processo</a>
          </template>
          <template v-else>
            <p>
              A pessoa responsável por este processo (e pelo boleto) é &#8203;
              <a :href="`mailto:${responsibleUsers[proc.NewSuiPayment.sui_user_id].NewSuiUser.email}`">
                &#8203;{{
                responsibleUsers[proc.NewSuiPayment.sui_user_id].NewSuiUser.name + ' ' + responsibleUsers[proc.NewSuiPayment.sui_user_id].NewSuiUser.surname
                }}&#8203;
              </a>.
            </p>
          </template>
        </div>
      </header>



      <div class="mult-main-content">
        <template
                v-for="team in teamsByProcess[proc.NewSuiApplication.id]"
        >
          <div
                  v-if="showTeam[team.NewSuiApplication.id]"
                  :key="`team-${team.NewSuiApplication.id}`"
                  class="team-container"
                  :class="statusMap[team.NewSuiApplication.status]"
          >
            <div class="control" v-if="currentSubsModel === 'preonhb'">
              <div>
                <span v-if="proc.NewSuiApplication.is_active != '1'">
                  <a href="" class="warning-action" @click.prevent="cancelProcess(proc, teamsByProcess[proc.NewSuiApplication.id])">Cancelar este processo</a>
                </span>
                <span v-if="alreadyStarted && teamsByProcess[proc.NewSuiApplication.id][0].NewSuiApplication.status === 'completed' && proc.NewSuiApplication.is_active != '1'">
                  <a href="https://prova.olimpiadadehistoria.com.br/prova/pre_onhb2020/iniciar">INICIAR A PRÉ-ONHB</a>
                </span>
                <span v-if="alreadyStarted && proc.NewSuiApplication.status === 'completed' && proc.NewSuiApplication.is_active == '1'">
                  Você já acessou a prova, por isto não é mais possível editar a inscrição:
                </span>
                <span v-if="alreadyStarted && proc.NewSuiApplication.status === 'completed' && proc.NewSuiApplication.is_active == '1'">
                  <a href="https://prova.olimpiadadehistoria.com.br/prova/pre_onhb2020/qg/equipe">ACESSAR A PRÉ-ONHB</a>
                </span>
              </div>
            </div>
            <div class="team-issue-summary">
              <p>
                >>>
                <template v-if="team.NewSuiApplication.status=='completed'">
                  <template v-if="!alreadyStarted">
                    Esta equipe está apta a participar
                  </template>
                  <template v-if="alreadyStarted">
<!--                    <a class="btn-action" v-if="team.NewSuiApplication.is_active != '1'" href="https://prova.omu.preface.com.br/prova/omu2025/iniciar">INICIAR A 41ª OMU COM ESTA EQUIPE</a>-->
<!--                    <a class="btn-action" v-if="team.NewSuiApplication.is_active == '1'" href="https://prova.omu.preface.com.br/prova/omu2025/qg/equipe">ACESSAR A 41ª OMU</a>-->
                    <a class="btn-action" v-if="team.NewSuiApplication.team_description == 'alfa'" href="https://prova.omu.preface.com.br/prova/omu_2025_alfa/qg/equipe">ACESSAR A 41ª OMU</a>
                    <a class="btn-action" v-if="team.NewSuiApplication.team_description == 'beta'" href="https://prova.omu.preface.com.br/prova/omu_2025_beta/qg/equipe">ACESSAR A 41ª OMU</a>
                  </template>
                </template>
                <template
                        v-if="team.NewSuiApplication.status=='in_proccess'"
                >Esta equipe ainda tem pendências</template>
                <template
                        v-if="team.NewSuiApplication.status=='user_cancelled'"
                >Esta equipe foi cancelada</template>
                &lt;&lt;&lt;
              </p>
            </div>

            <header>
              <div>
                <span class="team-counter">{{team.NewSuiApplication.code}}</span>
                <template v-if="!team.Ephemeral.editingName">
                  <h4>
                    {{ !team.NewSuiApplication.team_name ? '— — — —' : team.NewSuiApplication.team_name }}
                    <br />
                    <template  v-if="proc.NewSuiApplication.sui_user_id == myId || responsibleUsers[myId]">
                      <a href="" @click.prevent="editTeamName(team.NewSuiApplication.id)" class="generic-link" v-if="team.NewSuiApplication.is_active == '0' && teamSubsStillGoing">
                        {{ !team.NewSuiApplication.team_name ? 'Dar&nbsp;um&nbsp;nome' : 'Trocar&nbsp;este&nbsp;nome'}}
                      </a>
                      <br>
                      <a href="" v-if="team.NewSuiApplication.team_name && team.NewSuiApplication.status !== 'completed' && teamSubsStillGoing" @click.prevent="cleanTeamName(team.NewSuiApplication.id)" class="generic-link">
                        Limpar o nome
                      </a>
                    </template>
                    <template  v-if="proc.NewSuiApplication.sui_user_id != myId && !responsibleUsers[myId]">
                      <p style="font-size:10px; margin-top: 5px;">Apenas o responsável pela inscrição e o professor responsável podem nomear a equipe</p>
                    </template>
                  </h4>
                </template>
                <template v-if="team.Ephemeral.editingName">
                  <div class="team-name-container small-fields">
                    <label class="generic-label" :for="`team-name-${team.NewSuiApplication.id}`">Nome da equipe</label>
                    <input
                            :id="`team-name-${team.NewSuiApplication.id}`"
                            type="input"
                            class="generic-input"
                            v-on:keyup.enter="updateChangedTeamName(team.NewSuiApplication.id)"
                            :value="team.Edit.NewSuiApplication.team_name"
                            @input="changeTeamName(team.NewSuiApplication.id, $event.target.value)"
                    />
                    <button class="btn-action small" @click="updateChangedTeamName(team.NewSuiApplication.id)" :disabled="amILoading || !teamSubsStillGoing || team.NewSuiApplication.is_active == '1'">Salvar nome</button>
                  </div>
                </template>
              </div>
              <div class="coupon-info" v-if="!hasCoupon(team) && hasDiscountAvailable(team)">
                <p>
                  <em v-if="hasDiscountAvailable(team).type == 'state'">
                    Vocês têm um desconto disponível por ser a primeira equipe do estado a se inscrever.
                    Após clicar no link abaixo, será necessário atualizar a cobrança vinculada a esta inscrição para ter o desconto aplicado.
                    Todas as inscrições com desconto serão checadas e, caso os dados declarados não sejam verdadeiros, a equipe será desclassificada.
                  </em>
                  <em v-else>
                    Vocês têm um desconto disponível por ser uma das primeiras equipes só de meninas a se inscrever.
                    Após clicar no link abaixo, será necessário atualizar a cobrança vinculada a esta inscrição para ter o desconto aplicado.
                    Todas as inscrições com desconto serão checadas e, caso os dados declarados não sejam verdadeiros, a equipe será desclassificada.
                  </em>
                  <br>
                  <a class="generic-link" href="" @click.prevent="useCoupon(proc, team, hasDiscountAvailable(team).sui_coupon_id, hasDiscountAvailable(team).sui_coupon_code)">Usar o desconto</a>
                </p>
              </div>
              <div class="coupon-info" v-if="hasCoupon(team)">
                <p>
                  <em>
                    Vocês estão usando um cupom de desconto para sua inscrição. Código do cupom:
                    <span v-if="team.NewSuiCoupon && team.NewSuiCoupon.code"><strong>{{team.NewSuiCoupon.code}}</strong>.</span>
                    <span v-if="proc.NewSuiApplication.status != 'completed' && team.NewSuiCoupon && !team.NewSuiCoupon.used">
                      Não se esqueça de
                      <a href="" @click.prevent="createNewBillet(proc)" v-if="subsStillGoing">atualizar a cobrança</a>
                      vinculada a esta inscrição para ter o desconto aplicado.
                    </span>
                  </em>
                </p>
              </div>
              <div class="aux-info" v-if="currentSubsModel == 'onhb'" >
                <p class="school-name">{{ proc.NewSuiInstitution.name }}</p>
                <p class="overseer">{{ proc.NewSuiUser.full_name}} </p>
                <p class="payment-responsibility-name">{{ proc.NewSuiPayment.responsible_name }} </p>
              </div>
              <div class="aux-info" v-else >
                <p class="modality-info">{{{"pre_individual":"Individual", "pre_residencia":"Domicilio","pre_zapzap": "Zap-zap"}[proc.NewSuiApplication.modality] }}</p>
              </div>
            </header>
            <ul class="member-list">
              <li
                      class="team-member-container"
                      v-for="(member, i) in team.NewSuiApplicationsNewSuiUser"
                      :key="`team-${member.sui_user_id}`"
              >

                <team-member-def
                        :member="members[member.sui_user_id]"
                        :role="member.role_code"
                        :index="i + 1"
                        :status="team.NewSuiApplication.status"
                        :edit-only-grade="(proc.NewSuiApplication.modality === 'student' && member.sui_user_id == myId)|| member.sui_user_id == proc.NewSuiApplication.sui_user_id"
                        :can-edit="team.NewSuiApplication.is_active == '0' && (currentSubsModel != 'onhb' || ((proc.NewSuiApplication.sui_user_id == myId && member.sui_user_id != myId) || ((proc.NewSuiApplication.sui_user_id != myId || proc.NewSuiApplication.modality == 'wildcard') && team.NewSuiApplicationsNewSuiUser[0].sui_user_id == myId)))"
                        :team-id="team.NewSuiApplication.id"
                        :exemption-elligibility="processesExemptionElligibilityById[proc.NewSuiApplication.id]"
                        :exemption-request="false"
                        :subs-model="currentSubsModel"
                        :modality="proc.NewSuiApplication.modality"
                />
              </li>
            </ul>

            <div class="team-status" v-if="team.NewSuiApplication.status != 'user_cancelled' && currentSubsModel == 'onhb'">
              <ul>
                <li class="issues-title">Pendências desta equipe >>></li>
                <li
                        v-for="(value, key, index) in teamIssuesList[team.NewSuiApplication.id]"
                        :class="{ 'issue-done': value, 'issue-pending': !value }"
                        :key="`issues-team-${team.NewSuiApplication.id}-${index}`"
                >
                  <font-awesome-icon v-if="value" icon="check" />
                  <font-awesome-icon v-else icon="times" />
                  {{ {"has_teacher":"Equipe tem professor(a) responsável","has_all_students":"Três estudantes com conta","paid":"Boleto quitado","named":"Equipe nomeada"}[key] }}
                </li>
              </ul>
            </div>
          </div>
        </template>
      </div>

    </section>

    <div class="que-aparece-dentro" v-if="modalShown && cancelApplicationShown">
      <div class="window">
        <h3>Cancelamento do processo de inscrição {{cancellingApp.NewSuiApplication.code}}</h3>
        <p>
          Este processo contempla a inscrição de  {{teamsByProcess[cancellingApp.NewSuiApplication.id].length}}
          equipe{{teamsByProcess[cancellingApp.NewSuiApplication.id].length != 1 ? 's' : ''}} {{teamsByProcess[cancellingApp.NewSuiApplication.id].length === noNameCount ? 'ainda sem nome' : ''}}<span v-if="cancellingApp.NewSuiInstitution.id">
            vinculada{{teamsByProcess[cancellingApp.NewSuiApplication.id].length != 1 ? 's' : ''}} à instituição {{cancellingApp.NewSuiInstitution.name}}
          </span>{{teamsByProcess[cancellingApp.NewSuiApplication.id].length === noNameCount ? '.' : ':'}}
        </p>
        <ul v-if="teamsByProcess[cancellingApp.NewSuiApplication.id].length !== noNameCount">
          <li v-for="team in teamsByProcess[cancellingApp.NewSuiApplication.id]" :key="team.NewSuiApplication.id" v-if="team.NewSuiApplication.team_name">
            {{ team.NewSuiApplication.team_name }}
          </li>
          <li v-if="noNameCount">+ {{noNameCount}} equipe{{noNameCount===1 ? '' : 's'}} sem nome</li>
        </ul>
        <p v-else><br></p>

        <div v-if="cancellingApp.NewSuiPayment.id">
          <h3>Boleto</h3>
          <p>
            <strong v-if="cancellingApp.NewSuiPayment.status === 'waiting'">Aguardando pagamento</strong>
            <strong v-if="cancellingApp.NewSuiPayment.status === 'expired'">Vencido</strong>
            <strong v-if="cancellingApp.NewSuiPayment.status === 'user_cancelled'">Cancelado</strong>
            <br>
            Número do Documento: OMU{{cancellingApp.NewSuiPayment.id}}
          </p>
          <br>
          <p>
            Ao continuar {{teamsByProcess[cancellingApp.NewSuiApplication.id].length === 1 ? 'a equipe será cancelada' :
            'as equipes serão canceladas'}} e o boleto também. <br>
            Portanto, não pague este boleto!
          </p>
        </div>
        <p v-else>
          Ao continuar {{teamsByProcess[cancellingApp.NewSuiApplication.id].length === 1 ? 'a equipe será cancelada' :
          'as equipes serão canceladas'}}, o que liberará seus membros para participar em outra(s) inscrição(ões).
        </p>

        <div class="pop-buttons">
          <button class="btn light" @click="abortNewBillet()" :disabled="amILoading">Voltar</button>
          <button class="btn" @click="postCancelApplication()" :class="{'btn-loading': amILoading}"  :disabled="amILoading || !subsStillGoing">Cancelar processo de inscrição</button>
        </div>
      </div>
    </div>

    <div class="que-aparece-dentro" v-if="modalShown && newBilletShown">
      <div class="window">
        <h3>Novo boleto para inscrição</h3>
        <template v-if="currentModality==='student'">
          <div class="report-container">
            <p>
              O boleto a ser gerado refere-se à inscrição <strong>#{{newBilletApp.NewSuiApplication.id}}</strong> (código {{newBilletApp.NewSuiApplication.code}}) de
              uma equipe da instituição <span class="mono">{{newBilletApp.NewSuiInstitution.name}},</span>
              escola {{schoolType(newBilletApp.NewSuiInstitution.type)}} de registro
              <span class="mono">{{newBilletApp.NewSuiInstitution.id}},</span>
              sediada em {{newBilletApp.NewSuiInstitution.city}},&nbsp;{{newBilletApp.NewSuiInstitution.state}}.
            </p>
          </div>
        </template>
        <template v-if="currentModality==='teacher'">
          <div class="report-container">
            <p>
              O boleto a ser gerado refere-se à inscrição <strong>#{{newBilletApp.NewSuiApplication.id}}</strong> (código {{newBilletApp.NewSuiApplication.code}}) de
              {{numberOfTeams}} equipe{{numberOfTeams != 1 ? 's' : ''}} da instituição
              <span class="mono">{{newBilletApp.NewSuiInstitution.name}},</span> escola
              {{schoolType(newBilletApp.NewSuiInstitution.type)}} de registro
              <span class="mono">{{newBilletApp.NewSuiInstitution.id}},</span>
              sediada em {{newBilletApp.NewSuiInstitution.city}},&nbsp;{{newBilletApp.NewSuiInstitution.state}}.
            </p>
          </div>
        </template>
        <template v-if="currentModality==='wildcard'">
          <div class="report-container" id="wildcard-report">
            <p id="invited-teachers-summary">
              Inscrição <strong>#{{newBilletApp.NewSuiApplication.id}}</strong> (código {{newBilletApp.NewSuiApplication.code}}) de {{numberOfTeams}} equipe{{numberOfTeams != 1 ? 's' : ''}} com {{teacherList.length}}
              professor{{teacherList.length != 1 ? 'es(as) responsáveis' : '(a) responsável'}}.
            </p>
            <p>
              {{numberOfTeams != 1 ? 'As equipes estarão associadas' : 'A equipe estará associada'}}
              à <span class="mono">{{newBilletApp.NewSuiInstitution.name}},</span>
              escola {{schoolType(newBilletApp.NewSuiInstitution.type)}}
              de registro <span class="mono">{{newBilletApp.NewSuiInstitution.id}},</span>
              sediada em {{newBilletApp.NewSuiInstitution.city}},&nbsp;{{newBilletApp.NewSuiInstitution.state}}.
            </p>
          </div>
        </template>
        <br>
        <div class="report-container">
          <em>
            Caso tenha cupom(ns) de desconto aplicado(s), o valor do boleto o(s) contemplará.
            Caso o desconto seja no valor total, não haverá cobrança e os dados aqui informados serão apenas
            para registro do uso do(s) cupom(ns).
          </em>
        </div>
        <br><br>
        <div class="small-fields">
          <h3>Responsável pelo boleto</h3>
          <p>Os dados do boleto antigo foram copiados aqui para a sua conveniência.<br>Porém, se atrapalhar, é possível
            <a href="" @click.prevent="clearPaymentForm()">limpar o formulário</a>.
          </p>
          <br><br>
          <div class="single-field-container">
            <label class="generic-label" for="full-name">Nome completo</label>
            <input type="text" class="generic-input" id="full-name" v-model="payName"/>
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="cpf-cnpj">CPF / CNPJ</label>
            <input type="text" class="generic-input" id="cpf-cnpj" v-model="payCnpjCpf"/>
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="cep">CEP</label>
            <input type="text" class="generic-input" id="cep" v-model="payPostalCode" maxlength="9" />
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="state">Estado (UF)</label>
            <select class="generic-input" id="state" v-model="payState">
              <option v-for="state in stateList" v-bind:value="state.id" v-bind:key="state.id">
                {{ state.name }}
              </option>
            </select>
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="city">Cidade</label>
            <input type="text" class="generic-input" id="city" v-model="payCity" />
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="address">Logradouro (rua/avenida/etc)</label>
            <input type="text" class="generic-input" id="address" v-model="payAddressLine" />
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="number">Número</label>
            <input type="number" class="generic-input" id="number"  v-model="payNumber" />
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="extra">Complemento <small>(opcional)</small></label>
            <input type="text" class="generic-input" id="extra" v-model="payExtra" />
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="neighbor">Bairro</label>
            <input type="text" class="generic-input" id="neighbor" v-model="payNeighbor" />
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="phone">Telefone de contato (com DDD)</label>
            <input type="text" class="generic-input" id="phone" v-model="payPhone" />
          </div>
          <div class="single-field-container">
            <label class="generic-label" for="email">Email de contato </label>
            <input type="text" class="generic-input" id="email" v-model="payEmail" />
          </div>
        </div>
        <br>
        <br>
        <p>
          Observação: o boleto atual, emitido em nome de
          <strong>{{newBilletApp.NewSuiPayment.responsible_name}}</strong>, com
          vencimento em {{newBilletApp.NewSuiPayment.due_date | dateToBr}} e
          <strong>código {{newBilletApp.NewSuiPayment.code}}</strong>
          será cancelado e não deverá ser pago.
        </p>
        <br>

        <div id="hacky-divider"></div>

        <div class="pop-buttons">
          <button class="btn" @click="abortNewBillet()" :disabled="amILoading || !subsStillGoing">Cancelar</button>
          <button class="btn" @click="postCreateNewBillet()" :class="{'btn-loading': amILoading}"  :disabled="amILoading || !subsStillGoing">Atualizar a cobrança</button>
        </div>

      </div>
    </div>

    <div class="que-aparece-dentro" v-if="modalShown && alreadyPaidShown">
      <div class="window">
        <h3>O que fazer se você já pagou esse boleto?</h3>
        <div>
          <br/>
          <p>Primeiro verifique o seguinte:</p>
          <ol>
            <li> Se o seu comprovante de pagamento não é um comprovante de agendamento, caso seja um comprovante de agendamento, solicite ao banco o comprovante do pagamento.</li>
            <li> Verifique no comprovante se o código do boleto escrito corresponde ao código do boleto desse pagamento. </li>
            <li> Verifique se o boleto foi pago antes do vencimento que consta no boleto.</li>
            <li> Verifique se o código do processo de inscrição que está escrito no boleto corresponde ao código do processo de inscrição.</li>
          </ol>

          <p>Tendo verificado tudo isto, instruímos você a solicitar o processamento manual deste pagamento.</p>

          <p>Para isto, abra um chamado no formulário de dúvidas da 13ª ONHB, <strong> até dia 2 de maio de 2021</strong>, e inclua as seguintes informações:</p>

          <ul>
            <li>No assunto da dúvida escolha <strong>"Solicitação de processamento manual de pagamento"</strong></li>
            <li>Informe o <strong>código do processo de inscrição</strong> na solicitação. (codigo de letras e números embaixo do processo de inscrição)</li>
            <li>Informe o <strong>código do boleto pago</strong> por completo na solicitação.</li>
            <li>Informe o <strong>dia em que o boleto foi pago</strong>.</li>
          </ul>

          <p><a href="https://www.olimpiadadehistoria.com.br/paginas/onhb13/duvidas" target="_blank">Abra aqui o formulário de contato</a></p>

          <p>Então, caso todas as informações estiverem em ordem, você receberá um e-mail de resposta solicitando uma imagem do comprovante.
          </p>
          <p>
          Responda o e-mail com o comprovante em anexo. Se o pagamento informado estiver dentro de todos os critérios que constam no regulamento, efetuaremos manualmente a confirmação da sua inscrição.
          </p>
        </div>

        <div id="hacky-divider"></div>

        <div class="pop-buttons">
          <button class="btn" @click="closeAlreadyPaid()">OK, entendi</button>
        </div>

      </div>
    </div>
  </section>

</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import store from "../../store";
import TeamMemberDef from "./TeamMemberDef";
import Vue from "vue";
import stateList from "../../assets/state-list";
import {alert_validation_messages} from "../../lib/util";
import {mockData, pickOne} from "../../assets/mock-data";

export default {
  name: "StepTeams",
  components: {
    TeamMemberDef
  },
  props: {
    "highlightProcess": {
      required: false
    }
  },
  created() {
    store.commit("START_LOADING");

    let highlightProcess;

    if (typeof this.highlightProcess != "undefined") {
      highlightProcess = this.highlightProcess;
    }

    store.dispatch("updateTeamsList").then(function(){
      let applicationIds = Object.keys(store.state.Applications);

      if (applicationIds.length > 0 && typeof highlightProcess != "undefined" && store.getters.teamSubsStillGoing) {
        store.commit("OPEN_BILLET_WARN", {applicationId: highlightProcess});
      }

      store.commit("END_LOADING");
    });
  },
  data() {
    return {
      "stateList":  stateList,
      "alreadyPaidShown": false,
      statusMap: {
          "completed": "status-go",
          "in_proccess": "status-waiting",
          "user_cancelled": "status-cancelled"
      },
      selectedFilters: {
        "Todas as equipes": true,
        "Equipe tem professor(a) responsável": false,
        "Três estudantes com conta": false,
        "Boleto quitado": false,
        "Equipe nomeada": false
      },
      me: { id: "394" },
      registrationProcesses: [
        {
          strangeAnimal: "cação-anjo-do-atlântico predestinado",
          code: "2020.1049033",
          schoolName: "EMEF PROF DULCE BENTO NASCIMENTO",
          paymentOverseer: {
            id: "394",
            email: "calua@gmail.com",
            fullName: "Caluã Pataca"
          },
          paymentDetected: false,
          paymentDeadline: "3/4/2020",
          teams: [
            {
              cancelled: false,
              name: "Os Batutinhas",
              tempTeamName: "",
              isEditingTeamName: false,
              id: "1",
              registrationOverseer: "calua@gmail.com",
              teacher: {
                id: "394",
                name: "Caluã",
                surname: "Pataca",
                email: "calua@gmail.com",
                status: "confirmed"
              },
              students: [
                {
                  id: "30394",
                  name: "Lucas",
                  surname: "Reis",
                  email: "lucas@gmail.com",
                  status: "invited",
                  grade: "9º/Fund"
                },
                {
                  id: "30354",
                  name: "Daniel",
                  surname: "Abrahão",
                  email: "daniel@gmail.com",
                  status: "rejected_invitation",
                  grade: "8ª/Fund"
                },
                {
                  id: "302",
                  name: "",
                  surname: "",
                  email: "",
                  status: "vacant",
                  grade: ""
                }
              ]
            },
            {
              cancelled: false,
              name: "",
              id: "2",
              registrationOverseer: "calua@gmail.com",
              tempTeamName: "",
              isEditingTeamName: false,
              teacher: {
                id: "394",
                name: "Caluã",
                surname: "Pataca",
                email: "calua@gmail.com",
                status: "confirmed"
              },
              students: [
                {
                  id: "33567394",
                  name: "Leca",
                  surname: "Pedro",
                  email: "leca@gmail.com",
                  status: "confirmed",
                  grade: ""
                },
                {
                  id: "",
                  name: "",
                  surname: "",
                  email: "",
                  status: "vacant",
                  grade: ""
                },
                {
                  id: "302",
                  name: "",
                  surname: "",
                  email: "",
                  status: "vacant",
                  grade: ""
                }
              ]
            }
          ]
        },
        {
          strangeAnimal: "tubarão desconfiado",
          code: "2020.1043533",
          schoolName: "EMEF PROF DULCE BENTO NASCIMENTO",
          paymentOverseer: {
            id: "394",
            email: "calua@gmail.com",
            fullName: "Caluã Pataca"
          },
          paymentDetected: true,
          paymentDeadline: "3/4/2020",
          teams: [
            {
              cancelled: true,
              name: "Nois Trupica Marx Durkheim",
              tempTeamName: "",
              isEditingTeamName: false,
              id: "43",
              registrationOverseer: "calua@gmail.com",
              teacher: {
                id: "394",
                name: "Caluã",
                surname: "Pataca",
                email: "calua@gmail.com",
                status: "confirmed"
              },
              students: [
                {
                  id: "30315794",
                  name: "Jonas",
                  surname: "Doninha",
                  email: "jdoninha@gmail.com",
                  status: "rejected_invitation",
                  grade: "9º/Fund"
                },
                {
                  id: "1154",
                  name: "Ana",
                  surname: "Pulga",
                  email: "aka@gmail.com",
                  status: "rejected_invitation",
                  grade: "8ª/Fund"
                },
                {
                  id: "302",
                  name: "",
                  surname: "",
                  email: "",
                  status: "vacant",
                  grade: ""
                }
              ]
            },
            {
              cancelled: false,
              name: "Bacurau",
              tempTeamName: "",
              isEditingTeamName: false,
              id: "7862",
              registrationOverseer: "calua@gmail.com",
              teacher: {
                id: "394",
                name: "Caluã",
                surname: "Pataca",
                email: "calua@gmail.com",
                status: "confirmed"
              },
              students: [
                {
                  id: "6780",
                  name: "John",
                  surname: "Lennon",
                  email: "jonnyboy@gmail.com",
                  status: "confirmed",
                  grade: "1º/Médio"
                },
                {
                  id: "68211",
                  name: "Paul",
                  surname: "MaCarta",
                  email: "macartinha@gmail.com",
                  status: "confirmed",
                  grade: "1º/Médio"
                },
                {
                  id: "25",
                  name: "Jorge",
                  surname: "Filhodeharry",
                  email: "giorgitto@gmail.com",
                  status: "confirmed",
                  grade: "8º/Fund."
                }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "amILoading",
      "modalShown",

      "cancelApplicationShown",

      "newBilletShown",
      "currentModality",
      "chosenSchoolData",
      "teacherList",
      "registrationCost",
      "numberOfTeams",
      "currentSubsModel",
      "subsStillGoing",
      "teamSubsStillGoing",
      "alreadyStarted"
    ]),
    payName:        { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_name;},             set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_name", value});} },
    payCnpjCpf:     { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_document;},         set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_document", value});} },
    payAddressLine: { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address;},          set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address", value});} },
    payNumber:      { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_number;},   set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_number", value});} },
    payNeighbor:    { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_neighbor;}, set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_neighbor", value});} },
    payExtra:       { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_2;},        set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_2", value});} },
    payState:       { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_state;},    set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_state", value});} },
    payCity:        { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_city;},     set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_city", value});} },
    payPostalCode:  { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_address_cep;},      set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_address_cep", value});} },
    payPhone:       { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_telephone;},        set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_telephone", value});} },
    payEmail:       { get: function(){ return store.state.Subscription.Ephemeral.Payment.responsible_email;},            set:  function(value){store.commit("PAY_FORM_CHANGE", {field: "responsible_email", value});} },
    myId: function() {
      return store.state.User.NewSuiUser.id;
    },
    noNameCount () {
      return store.state.Interface.cancellingApplication.children.reduce(function (acc, child) {
        return acc + (child.NewSuiApplication.team_name ? 0 : 1)
      }, 0)
    },
    processes: function () {
      var processes = [], i;

      for (i = 0; i < store.state.ApplicationsOrder.length; i++) {
        processes.push(store.state.Applications[store.state.ApplicationsOrder[i]]);
      }

      return processes;
    },
    teamsByProcess: function() {
      var teams = {}, i, j, teamIds;

      for (i = 0; i < store.state.ApplicationsOrder.length; i++) {
        var appId;

        appId = store.state.ApplicationsOrder[i];
        teams[appId] = [];
      }

      teamIds = Object.keys(store.state.Teams);

      for (i = 0; i < teamIds.length; i++) {
        teams[store.state.Teams[teamIds[i]].NewSuiApplication.parent_application_id].push(store.state.Teams[teamIds[i]]);
      }

      return teams;
    },
    processesExemptionElligibilityById: function() {
      var processesElligibility = {}, i;

      for (i = 0; i < store.state.ApplicationsOrder.length; i++) {
        processesElligibility[store.state.Applications[store.state.ApplicationsOrder[i]].NewSuiApplication.id] =
          store.state.Applications[store.state.ApplicationsOrder[i]].NewSuiInstitution.type == 'public' ||
          store.state.Applications[store.state.ApplicationsOrder[i]].NewSuiInstitution.type == 'public_with_selection';
      }

      return processesElligibility;
    },
    members: function() {
      return store.state.Members;
    },
    responsibleUsers: function() {
      return store.state.ResponsibleUsers;
    },
    teamIssuesList: function() {
      var teamIds;
      var allIssues = {};
      var i;

      teamIds = Object.keys(store.state.Teams);

      for (i = 0; i < teamIds.length; i++) {
        let issues = {
          "has_teacher": false,
          "has_all_students": false,
          "paid": false,
          "named": false
        };

        let teamId = teamIds[i];

        if (store.getters.currentSubsModel === 'onhb') {
          let paymentProcessId = store.state.Teams[teamId].NewSuiApplication.parent_application_id;


          let teacherId = store.state.Teams[teamId].NewSuiApplicationsNewSuiUser[0].sui_user_id;
          let studentsIds = [
            store.state.Teams[teamId].NewSuiApplicationsNewSuiUser[1].sui_user_id,
            store.state.Teams[teamId].NewSuiApplicationsNewSuiUser[2].sui_user_id,
            store.state.Teams[teamId].NewSuiApplicationsNewSuiUser[3].sui_user_id
          ];

          if (store.state.Members[teacherId].NewSuiUser.user_status == "validated") {
            issues.has_teacher = true;
          }

          if (store.state.Members[studentsIds[0]].NewSuiUser.user_status == "validated"
                  && store.state.Members[studentsIds[1]].NewSuiUser.user_status == "validated"
                  && store.state.Members[studentsIds[2]].NewSuiUser.user_status == "validated") {
            issues.has_all_students = true;
          }

          if (store.state.Teams[teamId].NewSuiApplication.team_name != null && store.state.Teams[teamId].NewSuiApplication.team_name.length > 0) {
            issues.named = true;
          }

          if (store.state.Applications[paymentProcessId].NewSuiApplication.status == 'completed') {
            issues.paid = true;
          }
        }

        allIssues[teamId] = issues;
      }

      return allIssues;
    },
    showTeam: function() {
      let teamIds = Object.keys(store.state.Teams);
      let i;
      let show = {};

      for (i = 0; i < teamIds.length; i++) {
        if (this.selectedFilters["Todas as equipes"]) {
          show[teamIds[i]] = true;
          continue;
        }

        show[teamIds[i]] = false;

        //Implemented using or logic, as the wording of the layout suggests
        if (!this.teamIssuesList[teamIds[i]].has_teacher && this.selectedFilters["Equipe tem professor(a) responsável"]) {
          show[teamIds[i]] = true;
        }

        if (!this.teamIssuesList[teamIds[i]].has_all_students && this.selectedFilters["Três estudantes com conta"]) {
          show[teamIds[i]] = true;
        }

        if (!this.teamIssuesList[teamIds[i]].paid && this.selectedFilters["Boleto quitado"]) {
          show[teamIds[i]] = true;
        }

        if (!this.teamIssuesList[teamIds[i]].named && this.selectedFilters["Equipe nomeada"]) {
          show[teamIds[i]] = true;
        }

      }

      return show;
    },
    editableTeamCompositions: function() {
      let teams = {};
      this.registrationProcesses.forEach(regProc => {
        regProc.teams.forEach(team => {
          // payment overseers can change a team's composition (including
          // school staff), and also teachers.
          teams[team.id] =
            regProc.paymentOverseer.id == this.me.id ||
            team.teacher.id == this.me.id;
        });
      });
      return teams;
    },
    changeableTeamNames: function() { //@todo implement variants of this
      let teams = {};
      this.registrationProcesses.forEach(regProc => {
        regProc.teams.forEach(team => {
          // teacher can always change a team name. students can only
          // change it if they are the “paymentOverseer”, i.e. they
          // were the one registering the team.
          teams[team.id] =
            (regProc.paymentOverseer.id == this.me.id &&
              (team.students[0].id == this.me.id ||
                team.students[1].id == this.me.id ||
                team.students[2].id == this.me.id)) ||
            team.teacher.id == this.me.id;
        });
      });
      return teams;
    },
    newBilletApp: function () {
      return store.state.Interface.newBilletApplication
    },
    cancellingApp: function () {
      return store.state.Interface.cancellingApplication.application
    }
  },
  methods: {
    hasDiscountAvailable: function(team) {
      if (store.state.discountCoupon.sui_coupon_code && store.state.discountCoupon.team_id == team.NewSuiApplication.id ) {
        return store.state.discountCoupon;
      }
      else if (team.NewSuiCoupon && team.NewSuiCoupon.id) {
        return {
          sui_coupon_id: team.NewSuiCoupon.id,
          sui_coupon_code: team.NewSuiCoupon.code,
          type: team.NewSuiCoupon.type
        }
      }
      return false;
    },
    swapFilters: function(which) {
      if (
        which == "Todas as equipes" &&
        this.selectedFilters["Todas as equipes"] == true
      ) {
        return;
      }
      for (let key in this.selectedFilters) {
        if (key != which) {
          this.selectedFilters[key] = false;
        }
      }
      if (which != "") {
        if (this.selectedFilters[which]) {
          this.selectedFilters[which] = false;
          this.selectedFilters["Todas as equipes"] = true;
        } else {
          this.selectedFilters[which] = true;
        }
      } else {
        this.selectedFilters["Todas as equipes"] = true;
      }
    },
    editTeamName: function(teamId) {
      store.commit("OPEN_TEAM_NAME_EDIT", teamId);
    },
    showAlreadyPaid: function () {
      this.alreadyPaidShown = true;
      store.commit("START_MODAL");
    },
    closeAlreadyPaid: function () {
      this.alreadyPaidShown = false;
      store.commit("END_MODAL");
    },
    changeTeamName: function(teamId, value) {
      store.commit("CHANGE_TEAM_NAME", {teamId, value});
    },
    cleanTeamName: function(teamId) {
      if (store.state.amILoading) {
        return false;
      }

      store.commit("START_LOADING");
      let promise;
      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve) {
          setTimeout(function() {
            resolve()
          }, 800)
        });
      }
      else {
        let params = {
              action: "clean_team_name",
              sui_user: store.state.User.NewSuiUser.id,
              subscription: store.state.Subscription.subscription_slug,
              application: teamId
            };
        promise = Vue.axios.post('new_sui_application.json?' + (new URLSearchParams(params).toString()), {})
      }

      return promise
          .then(
            function (response) {
              if (!response.data.saved) {
                alert_validation_messages(response.data.validation, "Não foi possível atualizar o nome da equipe.");
                return Promise.reject('validation');
              }

              store.commit("UPDATE_TEAM_NAME", {teamId, value: ''});
            },
            function () {
              alert("Ocorreu uma falha ao atualizar o nome da equipe. Apenas o professor responsável e o responsável pela inscrição podem alterá-lo.");
            }
          )
          .finally(function () {
            store.commit("END_LOADING");
          });
    },
    updateChangedTeamName: function(teamId) {

      if (store.state.amILoading) {
        return false;
      }

      store.commit("START_LOADING");
      let promise, name = store.state.Teams[teamId].Edit.NewSuiApplication.team_name;
      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve) {
          setTimeout(function() {
            resolve()
          }, 800)
        });
      }
      else {
        let params = {
              action: "update_team_name",
              sui_user: store.state.User.NewSuiUser.id,
              subscription: store.state.Subscription.subscription_slug,
              application: teamId
            },
            data = {
              "NewSuiApplication": {"team_name": name}
            };
        promise = Vue.axios.post('new_sui_application.json?' + (new URLSearchParams(params).toString()), data)
      }

      return promise
        .then(
          function (response) {
            if (!response.data.saved) {
              alert_validation_messages(response.data.validation, "Não foi possível atualizar o nome da equipe.");
              return Promise.reject('validation');
            }

            store.commit("CLOSE_TEAM_NAME_EDIT", teamId);
            store.commit("UPDATE_TEAM_NAME", {teamId, value: name});
          },
          function () {
            alert("Ocorreu uma falha ao atualizar o nome da equipe. Apenas o professor responsável e o responsável pela inscrição podem alterá-lo.");
          }
        )
        .finally(function () {
          store.commit("END_LOADING");
        });
    },
    useCoupon: function(proc, team, couponId, couponCode) {
      Vue.set(proc.NewSuiPayment, 'sui_coupon_id', couponId);
      Vue.set(proc.NewSuiPayment, 'sui_coupon_code', couponCode);
      Vue.set(proc.NewSuiPayment, 'sui_coupon_application_id', team.NewSuiApplication.id);
      Vue.set(team.NewSuiApplication, 'sui_coupon_id', couponId);
      Vue.set(team.NewSuiCoupon, 'code', couponCode);
    },
    hasCoupon: function(application) {
      return application && application.NewSuiApplication && application.NewSuiApplication.sui_coupon_id;
    },
    createNewBillet: function (application) {
      store.commit("OPEN_NEW_BILLET_MODAL", application);
    },
    cancelProcess: function (application, children) {
      store.commit("OPEN_CANCEL_PROCESS_MODAL", {application, children});
    },
    abortCancelProcess: function () {
      store.commit("CLOSE_CANCEL_PROCESS_MODAL");
    },
    postCancelApplication: function () {
      if (store.state.amILoading) {
        return false;
      }
      store.commit("START_LOADING");

      let promise;
      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve, reject) {
          setTimeout(function() {
            let result = {};
            if (Math.random() < 0.9) {
              resolve(result);
            }
            else {
              reject(result);
            }
          }, 600)
        });
      }
      else {
        let application_id = store.state.Interface.cancellingApplication.application.NewSuiApplication.id,
            params = {
              sui_user: store.state.User.NewSuiUser.id,
              subscription: store.state.Subscription.subscription_slug
            };

        promise = Vue.axios.delete(`new_sui_application/${application_id}.json?${new URLSearchParams(params).toString()}`);
      }

      return promise.then(
        function (response) {
          if (!response.data.success) {
            alert('Não foi possível cancelar o processo.');
            return;
          }

          return store.dispatch("updateTeamsList")
                      .then(
                        function () {
                          store.commit("CLOSE_CANCEL_PROCESS_MODAL");
                        }
                      );
        },
        function (error) {
          alert("Ocorreu uma falha ao cancelar o processo.");
          return Promise.reject(error);
        }
      )
      .finally(function () {
        store.commit("END_LOADING");
      });
    },
    postCreateNewBillet: function () {
      if (store.state.amILoading) {
        return false;
      }
      store.commit("START_LOADING");
      store.commit("START_GENERATING_BILLET");

      let promise;
      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve, reject) {
          setTimeout(function() {
            let result = {data: pickOne(mockData.GenerateBillet)};
            if (typeof result.NewSuiPayment != "undefined") {
              resolve(result);
            }
            else {
              reject(result);
            }
          }, 600)
        });
      }
      else {
        let params = {
              sui_user: store.state.User.NewSuiUser.id,
              subscription: store.state.Subscription.subscription_slug,
              action: "generate_new_payment",
              application: store.state.Subscription.NewSuiApplication.id
            },
            data = {
              "NewSuiPayment": store.state.Subscription.Ephemeral.Payment,
              "NewSuiApplication": store.state.Subscription.NewSuiApplication
            };

        promise = Vue.axios.post('new_sui_application.json?' + (new URLSearchParams(params).toString()), data)
      }

      return promise.then(
          function (response) {
            if (!response.data.saved) {
              if (response.data.validation.NewSuiPayment) {
                alert_validation_messages(response.data.validation.NewSuiPayment, "Não foi possível emitir a cobrança.");
              }
              else {
                alert_validation_messages(response.data.validation, "Não foi possível emitir a cobrança.");
              }
              return Promise.reject('validation');
            }
            else {
              store.commit("REGISTER_JUST_SAVED_PROCESS", response.data.saved_id);
              store.commit("CLOSE_NEW_BILLET_MODAL");

              return store.dispatch("updateTeamsList").then(function(){
                let applicationIds = Object.keys(store.state.Applications);

                if (applicationIds.length > 0 && typeof response.data.saved_id) {
                  store.commit("OPEN_BILLET_WARN", {applicationId: response.data.saved_id});
                }
              });
            }
          },
          function (error) {
            alert("Ocorreu uma falha ao gerar o boleto.");
            return Promise.reject(error);
          }
        )
        .finally(function () {
          store.commit("END_GENERATING_BILLET");
          store.commit("END_LOADING");
        });
    },
    clearPaymentForm: function () {
      store.commit("CLEAR_BILLET_FORM");
    },
    abortNewBillet: function () {
      store.commit("CLOSE_NEW_BILLET_MODAL");
    },
    schoolType: function(type) {
      let types = { public: "pública", private: "privada" };
      if (type in types) {
        return types[type];
      }
      return type;
    }
  }
};

</script>

<style lang="scss" scoped>
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

.team-container {
  @extend .white-box;
  padding-bottom: 0;
  padding-top: 0;

  & + .team-container {
    margin-top: pad(2);
  }

  .mini-label {
    display: block;
    @extend .mono;
    @include fs(-2, 1.2);
    font-weight: 400;
    margin-top: -1 * pad(-3);
  }

  header {
    @extend .box-expander;
    padding: pad(0);

    display: grid;
    grid-template-columns: 1fr auto max-content;
    grid-gap: 40px;
    @include respond-below(sm) {
      grid-template-columns: 1fr;
      grid-row-gap: pad(0);
    }

    .aux-info {
      @include respond-above(sm) {
        grid-column: 3;
      }
    }

    .coupon-info {
      @include respond-above(sm) {
        grid-column: 2;
      }
    }

    p.overseer,
    p.payment-responsibility-name,
    p.school-name,
    p.modality-info{
      @include fs(-1);
      &:before {
        @extend .mini-label;
        margin-bottom: -1 * pad(-3);
      }
    }
    p.overseer:before {
      content: "Responsável";
    }
    p.payment-responsibility-name:before {
      content: "Pagamento por";
    }
    p.school-name:before {
      content: "Escola";
    }
    p.modality-info:before {
      content: "Modalidade";
    }

    .team-name-container {
      width: 80%;
      button {
        margin-top: pad(-1);
      }
    }

    .team-counter {
      &:before {
        /*counter-increment: numberOfTeams;*/
        content: "Equipe #"; /* counter(numberOfTeams);*/
        @extend .mini-label;
        margin-bottom: pad(-2);
      }
      @extend .mini-label;
      margin-bottom: pad(-2);
    }
    h4 {
      display: block;
      @include cancel-faux-caps;
      font-weight: bold;
      @include fs(1, 1.1);
      a {
        @extend .mono;
        @include fs(-2, 1.2);
        font-weight: 400;
      }
    }
  }

  $bw: 2px;
  border-radius: $bw * 2;

  &.status-go {
    border: $bw solid #74c365;
  }
  &.status-waiting {
    border: $bw solid #ffdb58;
  }
  &.status-cancelled {
    border: $bw solid tomato;
  }
}

.member-list {
  margin-bottom: pad(1);

  li + li {
    margin-top: pad(-2);
  }
}

.team-member-container {
  padding: 0;

  @extend .box-expander;
}

.team-issue-summary {
  $p: 20%;
  @extend .box-expander;
  padding: pad(-3) pad(0);

  @at-root .status-go & {
    background-color: mix(white, $status-ok, $p);
  }
  @at-root .status-waiting & {
    background: mix(white, $status-waiting, $p);
  }
  @at-root .status-cancelled & {
    background: mix(white, $status-cancelled, $p);
  }

  p {
    text-align: center;
    @extend .mono;
    @include faux-caps;
    @include fs(-2);
  }
}

.team-status {
  $p: 20%;
  @extend .box-expander;
  padding: pad(-1) pad(0);

  @at-root .status-go & {
    background-color: mix(white, $status-ok, $p);
  }
  @at-root .status-waiting & {
    background: mix(white, $status-waiting, $p);
  }
  @at-root .status-cancelled & {
    background: mix(white, $status-cancelled, $p);
  }
  &,
  ul li {
    @include fs(-2);
    @extend .mono;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(5, minmax(min-content, auto));

    grid-column-gap: pad(0);
    grid-row-gap: pad(-3);

    .issues-title {
      grid-row: 1 / span 2;
    }

    @include respond-between(sm, lg) {
      grid-template-columns: repeat(3, minmax(min-content, auto));
    }

    @include respond-below(sm) {
      grid-template-columns: max-content;
      .issues-title {
        grid-row: 1;
      }
    }
    li {
      svg {
        @include fs(-3);
      }
      &.issue-done {
        color: darken($status-ok, 35%);
      }
      &.issue-pending {
        color: $invalid;
      }
    }
  }
}

.switch-container {
  width: auto;
  align-items: center;
  display: grid;
  grid-template-columns: max-content max-content;
  grid-gap: pad(-1);
  padding-right: pad(0);

  @include respond-above(lg) {
    & + .switch-container {
      padding-left: pad(0);
      border-left: 1px solid grays(7);
    }
  }
  @include respond-between(sm, lg) {
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(5),
    &:nth-child(6) {
      padding-left: pad(0);
      border-left: 1px solid grays(7);
    }
  }
  @include respond-between(xs, sm) {
    &:nth-child(even) {
      padding-left: pad(0);
      border-left: 1px solid grays(7);
    }
  }

  .switch-label {
    cursor: pointer;
    user-select: none;
  }
}

#filter {
  background: grays(10);

  display: grid;
  padding: pad(-1) pad(1);
  margin-top: pad(0);

  width: calc(100% + 2 * #{pad(1)});
  margin-left: -1 * pad(1);

  @include box-shadow(0.2, 0.9);

  @include respond-above(sm) {
    top: 0;
    position: sticky;
  }

  z-index: 1;

  grid-template-columns: max-content repeat(5, min-content);
  align-items: center;

  @include respond-between(sm, lg) {
    grid-template-columns: repeat(3, auto);
    grid-row-gap: pad(-1);
  }
  @include respond-between(xs, sm) {
    grid-template-columns: auto auto;
    grid-row-gap: pad(-1);
  }
  @include respond-below(xs) {
    grid-template-columns: auto;
    grid-row-gap: pad(-1);
  }

  h3 {
    padding-right: pad(-1);
    margin: 0;
    @include fs(-1, 1);
    @extend .mono;
  }
}

.extender {
  width: calc(100% + 2 * #{pad(1)});
  position: relative;
  left: -1 * pad(1);
  padding-left: pad(1);
  padding-right: pad(1);
}

.registration-process {
  @extend .extender;
  padding-top: 0;
  padding-bottom: pad(1);
  border-top: 3px solid grays(9);
  margin-top: pad(2);
  & + .registration-process {
  }
}

.reg-proc-head {
  @extend .extender;
  padding: pad(0) pad(1);
  margin-bottom: pad(0);
  svg {
    @include fs(0);
    opacity: 0.6;
  }
  h2 {
    @include fs(4);
    font-weight: 300;
    opacity: 0.6;
  }
  h3 {
    margin-top: pad(-3);
    @include fs(1);
    @extend .mono;
    opacity: 0.7;
    font-weight: 400;
    font-style: italic;
  }
  .number-of-teams {
    position: relative;
    opacity: 0.6;
    top: -1 * pad(-1);
    @include fs(-1);
    @extend .mono;
  }
}

.payment-status {
  @extend .extender;
  margin-top: pad(-1);
  padding-top: pad(-2);
  padding-bottom: pad(-2);

  p {
    @extend .mono;
    @include fs(-1);
  }

  &.billet-was-paid {
    background: $status-ok;
  }
  &.billet-wasnt-paid-yet {
    background: $status-waiting;
  }
  &.billet-expired {
    background: $status-cancelled;
  }
}

.payment-responsibility {
  @extend .extender;
  background: grays(4);
  padding-top: pad(-2);
  padding-bottom: pad(-2);
  a,
  p {
    color: white;
    @extend .mono;
    @include fs(-1);
  }
  a + a {
    margin-right: pad(0)
  }
}

#non-constrained-main-content {
  counter-reset: numberOfTeams;
}

.hidden-team {
  @extend .mono;
  @include fs(-1, 1.1);
  opacity: 0.5;
  margin: pad(0) 0;

  cursor: pointer;

  &:before {
    counter-increment: numberOfTeams;
    color: grays(6);
    content: "Equipe #" counter(numberOfTeams) " / ";
    @extend .mini-label;

    cursor: default;
  }
}

#hacky-divider {
  grid-column: 2 / 3;
  border-right: 1px solid grays(8);

  @include respond-below(xs) {
    display: none;
  }
}

.control {
  padding: 0.5rem;
  div {
    display: flex;
    text-align: center;
    font-size: 80%;

	> * {
      flex-grow: 1;
      padding: 0 2em;
      margin-bottom: 3px;
	}

    .warning-action {
      color: red;
       &:hover {
         background-color: red;
         color: black;
       }
    }
  }
}
</style>
